import { render, staticRenderFns } from "./vip.vue?vue&type=template&id=629a1a40&"
import script from "./vip.vue?vue&type=script&lang=ts&"
export * from "./vip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports